module.exports = __webpack_public_path__ + "static/project7-a7ce0923fbca7004ba48205ee0461772.png";